"use client";

import ToolTip from "../../components/UI/ToolTip";
import classes from "./share-tooltip.module.css";
import { useAlertContext } from "@/context/alert";
import { Share } from "react-feather";

const ShareTooltip = (props) => {
  const { SET_ALERT } = useAlertContext();

  const copyToClipboard = () => {
    navigator?.clipboard.writeText(document.location.href);
    SET_ALERT({ msg: "Listing link copied!", type: "success" });
  };

  return (
    <div
      className={props.shareDivStyle ? props.shareDivStyle : classes.biShareDiv}
      onClick={copyToClipboard}
    >
      <ToolTip
        header="Copy Link"
        text={
          props?.text || props.text === ""
            ? props.text
            : "Unique furniture finds are better when shared with friends and family. So lets get to it!"
        }
      >
        {props?.styles?.includes("no border") ? (
          <div className={props?.div2Style ? props.div2Style : classes.share}>
            <Share
              className={
                props?.shareStyle ? props?.shareStyle : classes.biShare
              }
              size={props.size ? props.size : "small"}
            />
            <span
              className={
                props.shareTextStyle ? props.shareTextStyle : classes.shareText
              }
            >
              {" "}
              Share
            </span>
          </div>
        ) : (
          <div className={props?.div2Style ? props.div2Style : classes.share}>
            <Share
              className={
                props?.shareStyle ? props?.shareStyle : classes.biShare
              }
              size={props.size ? props.size : "small"}
            />
            <span
              className={
                props.shareTextStyle ? props.shareTextStyle : classes.shareText
              }
            >
              {" "}
              Share
            </span>
          </div>
        )}
      </ToolTip>
    </div>
  );
};

export default ShareTooltip;
